import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Button from '../elements/Button';

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  buttonHref: PropTypes.string
}

const defaultProps = {
  ...SectionProps.defaults,
  split: false,
  title: 'Ready to get started?',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua.',
  buttonText: 'Start free trial',
  buttonHref: '#0'
}

class Cta extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      split,
      title,
      description,
      buttonText,
      buttonHref,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'cta section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'cta-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider',
      split && 'cta-split'
    );

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div
            className={innerClasses}
          >
            <div className="container-xs">
              <div className="cta-slogan reveal-from-top">
                <h2 className="mt-0 mb-16">
                  {title}
                </h2>
                <p className="m-0">
                  {description}
                </p>
              </div>
              <div className="cta-action reveal-scale-up" data-reveal-delay="200">
                <Button tag="a" color="primary" wideMobile href={buttonHref}>
                  {buttonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;